import { useTranslation } from "react-i18next";

import { EmbeddedMediaPage } from "../components/EmbeddedMediaPage";

export const VideoMedia = () => {
  const { t } = useTranslation();
  return (
    <EmbeddedMediaPage
      category="VIDEO"
      headerPageTitle={t("pages.editor.media.video.header.title")}
      helpMessage={t("pages.editor.media.video.help.message")}
    />
  );
};
